import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { RouterLink } from '@angular/router'

import { TranslatePipe } from '@ngx-translate/core'
import { Button } from 'primeng/button'
import { map, takeUntil } from 'rxjs'

import { Action, CountryCodes, Resource } from '@ti/contracts'
import { ApiService } from '@ti/core/api'
import { Profile } from '@ti/core/auth/services'
import { TspProfile } from '@ti/core/auth/services/tsp.profile'
import { CheckAccessDirective } from '@ti/core/common/directives'
import { injectDestroy$, selectState } from '@ti/core/common/utils'
import { CONFIG } from '@ti/core/contracts/config'
import { CaseIconComponent } from '@ti/core/icons/case'
import { PlusIconComponent } from '@ti/core/icons/plus'
import { UsersIconComponent } from '@ti/core/icons/users'
import { FleetHeaderComponent } from '@ti/core/ui-kit/layout/components/fleet-header'
import { TooltipDirective } from '@ti/core/ui-kit/layout/directives'
import {
  UserAddDialogComponent,
  UserEditDialogComponent,
  UserFormMode,
  UsersGridComponent,
} from '@ti/shared/user'

import { provideTspUsersModel, TspUsersModel } from '../../models/users.model'

@Component({
  selector: 'app-tsp-admin-users-page',
  templateUrl: 'users-page.component.html',
  styleUrls: ['users-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideTspUsersModel()],
  imports: [
    Button,
    CheckAccessDirective,
    TooltipDirective,
    TranslatePipe,
    RouterLink,
    CaseIconComponent,
    PlusIconComponent,
    UsersGridComponent,
    AsyncPipe,
    UserEditDialogComponent,
    UserAddDialogComponent,
    UsersIconComponent,
    FleetHeaderComponent,
  ],
})
export class TspAdminUsersPageComponent {
  protected readonly api = inject(ApiService)
  protected readonly config = inject(CONFIG)
  protected readonly profile = inject(Profile)
  protected readonly tspProfile = inject(TspProfile)
  protected readonly model = inject(TspUsersModel)
  protected readonly state = selectState(TspUsersModel)
  protected readonly destroy$ = injectDestroy$()

  protected readonly Resource = Resource
  protected readonly Action = Action
  protected readonly CountryCodes = CountryCodes

  protected readonly tspCountry$ = this.tspProfile.tsp$.pipe(
    takeUntil(this.destroy$),
    map((tsp) => tsp?.country as CountryCodes),
  )

  protected readonly tspUsernamePrefix$ = this.tspProfile.tsp$.pipe(
    takeUntil(this.destroy$),
    map((tsp) => tsp?.usernamePrefix as CountryCodes),
  )

  protected readonly TYPES = { UserFormMode }
}
